import { http, httpFile } from './http_service';


//Get List cars with - Pagination
export function listPage(obj){
    let params = {
        page:obj.page, 
        recordsPerPage:obj.recordsPerPage, 
        q:obj.q, 
        selectedStatus:obj.selectedStatus, 
        sort_direction:obj.sort_direction, 
        sort_field:obj.sort_field
    }
    return http().get(`/cars/list-page`, {
        params:params
    });
}

//Get Single
export function single(id){
    return http().get(`/cars/single/${id}`);
}
//Add one
export function add(data){
    return http().post('/cars/add', data)
}
//Update
export function update(id, data){
    return http().post(`/cars/update/${id}`, data)
}






